import CSS from './ViewProfile.module.css';
import useUserDataStore from '../../../store/userDataStore';
import { NavLink, useNavigate } from 'react-router-dom';
import GuestSignInLogo from '../../header/GuestSignInLogo';

export default function ViewProfile({
  userName,
  sellerEmail,
  phoneNumber,
  image,
  toggleModal,
  location,
}) {
  const { email } = useUserDataStore((state) => state.userData);
  const navigate = useNavigate();
  return (
    <main>
      <div className={CSS.profilePic}>
        {image ? (
          <img src={image} alt='profile pic' className={CSS.profilePic} />
        ) : (
          <div className={CSS.guestIconWrapper}>
            <GuestSignInLogo fillColor={'var(--blue-text-bold)'} />
          </div>
        )}
      </div>
      <p className={CSS.userName}>{userName}</p>

      <section className={CSS.userContactsSection}>
        <p>
          <strong>Phone:</strong> {phoneNumber}
        </p>
        <p>
          <strong>Location: </strong> {location}
        </p>
        <p>
          <strong>Email: </strong> {sellerEmail}
        </p>
      </section>
      <div className={CSS.btnWrapper}>
        {sellerEmail === email ? (
          <button
            className={CSS.reportUserBtn}
            onClick={() => {
              if (toggleModal) toggleModal({ preventDefault: () => {} });
              navigate('./settings');
            }}>
            Edit Profile
          </button>
        ) : (
          <button className={CSS.reportUserBtn}>Report this seller</button>
        )}
      </div>
      <section className={CSS.moreItemsSection}>
        <strong>Items listed by seller</strong>
        <ul>
          <li>
            <div className={CSS.cardWrapper}>
              <div className={CSS.itemWrapper}>
                <div className={CSS.itemPic}></div>
                <div className={CSS.itemDetails}>
                  <p className={CSS.iPhoneDetailsText}>{`iPhone 8 (Black)`}</p>
                  <p>128 GB</p>
                </div>
              </div>
              <p>
                <strong>Looking for:</strong> Samsung S10
              </p>
            </div>
          </li>
        </ul>
      </section>
    </main>
  );
}
